<template>

  <ul class="maincategories-list">
    <li v-bind:class="['maincategories-list__item',category.slug]" v-for="category in categories" >
      <span v-bind:class="['maincategories-list__item-inner',category.is_active]" v-on:click.stop="active(category.id)">
        {{category.name}}
      </span>
    </li>
  </ul>

</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

interface SelectedItem {
  id: string,
  label: string
}

@Component
export default class FilterMainCategories extends Vue {
  @Prop({default: () => []}) categories: any;
  @Prop({default: () => []}) search: (model) => void;
  @Prop({default: () => {}}) model: any;

  private active(id: string) {
    this.model.tax_product_cat = id;
  }

}

</script>